import { Reducer } from 'redux';
import { EmailsState, EmailsActionTypes } from 'types';

const initialState: EmailsState = {};

const reducer: Reducer<EmailsState> = (state = initialState, action: any) => {
  switch (action.type) {
    case EmailsActionTypes.LIST_REFERRALS_EMAILS_START: {
      return {
        ...state,
        listing: true
      };
    }
    case EmailsActionTypes.LIST_REFERRALS_EMAILS_SUCCESS: {
      return {
        ...state,
        listing: false,
        emails: action.payload
      };
    }
    case EmailsActionTypes.LIST_REFERRALS_EMAILS_FAILURE: {
      return {
        ...state,
        listing: false,
        emails: []
      };
    }
    case EmailsActionTypes.LIST_RESPONSES_EMAILS_START: {
      return {
        ...state,
        listing: true
      };
    }
    case EmailsActionTypes.LIST_RESPONSES_EMAILS_SUCCESS: {
      return {
        ...state,
        listing: false,
        emails: action.payload
      };
    }
    case EmailsActionTypes.LIST_RESPONSES_EMAILS_FAILURE: {
      return {
        ...state,
        listing: false,
        emails: []
      };
    }
    case EmailsActionTypes.GET_REFERRAL_EMAIL_DETAIL_START: {
      return {
        ...state,
        loading: true,
        emailDetail: undefined
      };
    }
    case EmailsActionTypes.GET_REFERRAL_EMAIL_DETAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        emailDetail: action.payload
      };
    }
    case EmailsActionTypes.GET_REFERRAL_EMAIL_DETAIL_FAILURE: {
      return {
        ...state,
        loading: false,
        emailDetail: undefined
      };
    }
    case EmailsActionTypes.GET_RESPONSE_EMAIL_DETAIL_START: {
      return {
        ...state,
        loading: true,
        emailDetail: undefined
      };
    }
    case EmailsActionTypes.GET_RESPONSE_EMAIL_DETAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        emailDetail: action.payload
      };
    }
    case EmailsActionTypes.GET_RESPONSE_EMAIL_DETAIL_FAILURE: {
      return {
        ...state,
        loading: false,
        emailDetail: undefined
      };
    }
    case EmailsActionTypes.PREVIEW_RESPONSE_START:
    case EmailsActionTypes.PREVIEW_EMAIL_START: {
      return {
        ...state,
        previewing: true,
        emailPreview: undefined
      };
    }
    case EmailsActionTypes.PREVIEW_EMAIL_SUCCESS: {
      return {
        ...state,
        previewing: false,
        emailPreview: action.payload
      };
    }
    case EmailsActionTypes.PREVIEW_EMAIL_FAILURE: {
      return {
        ...state,
        previewing: false,
        emailPreview: undefined
      };
    }
    case EmailsActionTypes.RESEND_EMAIL_START: {
      return {
        ...state,
        resending: true,
        resendingToOther: undefined,
        resendedId: undefined
      };
    }
    case EmailsActionTypes.RESEND_EMAIL_SUCCESS: {
      return {
        ...state,
        resending: false,
        resendingToOther: undefined,
        resendedId: action.payload?.id
      };
    }
    case EmailsActionTypes.RESEND_EMAIL_FAILURE: {
      return {
        ...state,
        resending: false,
        resendingToOther: undefined,
        resendedId: undefined
      };
    }
    case EmailsActionTypes.RESEND_TO_OTHER_EMAIL_START: {
      return {
        ...state,
        resending: true,
        resendingToOther: true,
        resendedId: undefined
      };
    }
    case EmailsActionTypes.RESEND_TO_OTHER_EMAIL_SUCCESS: {
      return {
        ...state,
        resending: false,
        resendingToOther: false,
        resendedId: action.payload?.id
      };
    }
    case EmailsActionTypes.RESEND_TO_OTHER_EMAIL_FAILURE: {
      return {
        ...state,
        resending: false,
        resendingToOther: false,
        resendedId: undefined
      };
    }
    case EmailsActionTypes.DOWNLOAD_EMAIL_BODY_START: {
      return {
        ...state,
        downloading: true,
        emailBodyDownload: undefined
      };
    }
    case EmailsActionTypes.DOWNLOAD_EMAIL_BODY_SUCCESS: {
      return {
        ...state,
        downloading: false,
        emailBodyDownload: action.payload
      };
    }
    case EmailsActionTypes.DOWNLOAD_EMAIL_BODY_FAILURE: {
      return {
        ...state,
        downloading: false,
        emailBodyDownload: undefined
      };
    }
    case EmailsActionTypes.SET_EMAIL_SEARCH_FILTER: {
      return {
        ...state,
        filters: action.payload
      };
    }
    case EmailsActionTypes.CLEAR_EMAILS: {
      return initialState;
    }
    case EmailsActionTypes.CLEAR_EMAIL_BODY_DOWNLOAD: {
      return {
        ...state,
        downloading: false,
        emailBodyDownload: undefined
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as EmailsReducer };
